import { render } from "./OverlayBackground.vue?vue&type=template&id=63f05c1f"
import script from "./OverlayBackground.vue?vue&type=script&lang=js"
export * from "./OverlayBackground.vue?vue&type=script&lang=js"

import "./OverlayBackground.vue?vue&type=style&index=0&id=63f05c1f&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__